import device from "current-device";

// Отключает глобальный скролл
export function disablePageScroll() {
    $H.addClass('_disable-page-scroll');
}

// Включает глобальный скролл
export function enablePageScroll() {
    $H.removeClass('_disable-page-scroll');
}

export function isMobile() {
    return device.mobile();
}

export function isSmallTablet() {
    return window.matchMedia("(max-width: 650px)").matches;
}

export function isTablet() {
    return device.tablet();
}

export function isDesktop() {
    return device.desktop();
}

export function isWidth(width, flag) {
    if (flag) {
        return $W.width() < width;
    } else {
        return $W.width() > width;
    }
}

export function isObject(variable) {
    return variable !== null && typeof variable === 'object' && !Array.isArray(variable);
}

export async function postData(url = "", data = {}) {
    // Default options are marked with *
    const response = await fetch(url, {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
            "Content-Type": "application/json",
            'RequestVerificationToken': document.querySelector('input[name="__RequestVerificationToken"]').value
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(data), // body data type must match "Content-Type" header
    });
    return response.text(); // parses JSON response into native JavaScript objects
}

export async function postDataForm(url = "", data = {}) {
    const formData = new FormData();

    // Append each key-value pair to the formData object
    for (const key in data) {
        formData.append(key, data[key]);
    }

    // Default options are marked with *
    const response = await fetch(url, {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
            // Remove 'Content-Type': 'application/json' since FormData needs its own content type
            'RequestVerificationToken': document.querySelector('input[name="__RequestVerificationToken"]').value
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: formData  // Set the body to the formData object
    });
    return response.text(); // parses JSON response into native JavaScript objects
}

export function isTouchScreen() {
    return ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
}

export function updateCatalogDropdownHeight() {
    $('.js-header-catalog-main').css('max-height', `calc(100vh - ${$('.js-header').outerHeight()}px)`)
}

// equalHeights
export function equalHeights(selector) {
    let maxHeight = 0;
    if (!$(selector).length) return

    $(selector).each(function () {
        maxHeight = Math.max($(this).outerHeight(true), maxHeight);
    });
    $(selector).each(function () {
        $(this).css('min-height', maxHeight);
    });
}

// detect is IOS
export function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
}

export function readUploadedFileAsText(inputFile) {
    const temporaryFileReader = new FileReader();
    return new Promise((resolve, reject) => {
        temporaryFileReader.onerror = () => {
            temporaryFileReader.abort();
            reject(new DOMException("Problem parsing input file."));
        };
        temporaryFileReader.addEventListener("load", function () {
            resolve(temporaryFileReader.result.split(',')[1]);
        }, false);
        temporaryFileReader.readAsDataURL(inputFile.files[0]);
    });
}


export function updateURL(params, navigate = false) {
    let url = new URL(window.location.href);
    let searchParams = new URLSearchParams(url.search);

    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            if (params[key] === null) {
                searchParams.delete(key);
            } else {
                searchParams.set(key, params[key]);
            }
        }
    }
    url.search = searchParams.toString();

    if (navigate) {
        window.location.href = url.toString();
    } else {
        history.pushState(null, '', url.toString());
    }
}

export function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
